import { Flex } from "@mantine/core";

import { UnpublishedChangesIndicator } from "@/components/unpublished-changes-indicator";
import { INFO, UpwageBadge } from "@/components/upwage-badge";
import type { PropsWithTableInfo } from "@/types/third-party";
import type { Screener } from "@/types/screeners";

export const VersionCell = <TData extends Screener>({
  info,
}: PropsWithTableInfo<TData, string>) => {
  const version = info.getValue();
  const hasUnpublishedChanges = info.row.original.hasUnpublishedChanges;

  return (
    <Flex align="center" gap={8}>
      <UpwageBadge className="min-w-[42px]" colorVariant={INFO} filled>
        {version}
      </UpwageBadge>
      {hasUnpublishedChanges && <UnpublishedChangesIndicator />}
    </Flex>
  );
};
